import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useApprovers } from '../hooks/useApprovers';
import { useApprovalContext } from '../hooks/useApprovalContext';
import { maxNumberOfApprovers } from '../utils/approvalModalUtils';
import formatName from 'I18n/utils/formatName';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApproverSelect({
  value,
  onChange
}) {
  var _approval$meta$curren;
  const approval = useApprovalContext();
  const currentUserId = (_approval$meta$curren = approval.meta.currentUser) === null || _approval$meta$curren === void 0 ? void 0 : _approval$meta$curren.user_id;
  const {
    approvalType,
    approvalAction
  } = approval.meta;
  const {
    approvers,
    isLoading
  } = useApprovers(approvalType, approvalAction);
  const options = useMemo(() => approvers.filter(approver => approver.activeUserId !== currentUserId).map(item => {
    const searchableText = `${item.firstName} ${item.lastName} ${item.email}`;
    const formattedName = formatName({
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email
    });
    return Object.assign({
      // The text property is only used for searching when combined with buttonText and dropdownText.
      // The options displays the dropdownText when the dropdown is open and the buttonText is
      // displayed when the dropdown is closed and the option is selected.
      text: searchableText,
      dropdownText: formattedName,
      buttonText: formattedName,
      value: item.ownerId,
      help: item.email
    }, item);
  }), [currentUserId, approvers]);
  const onChangeApprover = evt => {
    onChange(evt.target.value);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvers"
    }),
    required: true,
    tooltipProps: {
      use: 'longform'
    },
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalModal.approverTooltip"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalModal.approverSelectHelp"
    }),
    error: value.length > maxNumberOfApprovers,
    validationMessage: value.length > maxNumberOfApprovers && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalSelectError",
      options: {
        maxNumberOfApprovers,
        count: value.length - maxNumberOfApprovers
      }
    }),
    children: /*#__PURE__*/_jsx(Select, {
      anchorType: "button",
      isLoading: isLoading,
      "data-test-id": "product-approvals-approver-select",
      value: value,
      onChange: onChangeApprover,
      options: options,
      multi: true,
      multiCollapseLimit: 3,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.selectApprover"
      })
    })
  });
}
export default ApproverSelect;